<template>
  <div>
    <v-row v-if="this.isAdmin" cols="12" sm="12" md="12" lg="12" class="row-menu-right mb-3 pr-3" style="margin-top: -50px;">
      <v-btn
        outlined
        class="button-color-outline head-search-button mr-1"
        :disabled="!allowBtnReject"
        @click="clickReject()"
      >
      {{ textBtnNO }}
      </v-btn>
      <v-btn
        class="button-color head-search-button ml-1 white--text text--lighten-4"
        elevation="0"
        :disabled="!allowBtnApprove"
        @click="clickApprove()"
      >
      {{ textBtnOk }}
      </v-btn>
    </v-row>
    <OverlayLoading :loading="loading" />
    <div>
      <v-data-table
        class="border-table-business text-no-wrap table-approve"
        item-key="_id"
        v-model="selected"
        :headers="headers"
        :items="dataSource"
        :loading="loading"
        :expanded.sync="expanded"
        loader-height=0
        loading-text="Loading... Please wait"
        :footer-props="{
          'items-per-page-options': [15, 30, 50, 100, -1],
          'items-per-page': 15
        }"
        :server-items-length="total || -1"
        @update:items-per-page="changePerPage"
        @update:page="changePage"
        :single-select="singleSelect"
        :show-select="this.isAdmin"
        @input="checkAllowBtn()"
        @toggle-select-all="selectAllToggle"
        disable-sort
        :page.sync="page"
        :items-per-page="perPage"
        hide-default-footer
        @page-count="pageCount = $event"
      >
      <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }">
          <v-checkbox
            v-if="item.status==='pending' && isAdmin"
            v-show="true"
            v-model="item.selected"
            :value="isSelected"
            hide-details
            class="ma-0"
            color="#2BA197"
            style="width: 0px;"
            @change="select($event)"
          />
        </template>
        <template v-slot:[`item.no`]="{ item }">
          {{ (perPage*(page-1)) + dataSource.indexOf(item)+1 }}
        </template>
        <!-- <template v-slot:[`item.companyImage`]="{ item }">
          <td style="width: fit-content !important;" class="py-2">
            <v-avatar
              size="50"
              rounded
            >
              <v-img
                contain
                :lazy-src="require('@/assets/icons/company-logo3.png')"
                :src="item.failed_image ? require('@/assets/icons/company-logo3.png') : item.companyImage"
                :alt="item.employeeId"
                v-on:error="onImgError(item.no-1)"
                aspect-ratio="2.7"
              />
            </v-avatar>
          </td>
        </template> -->
        <template v-slot:[`item.updateAt`]="{ item }">
          {{ item.updateAt }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
            <!-- :color="['approve','acknowledge'].includes(item.requestStatus)? '#ECF8EA': ['reject','cancel'].includes(item.requestStatus)? '#FBE5E4':'#ECF9FF'" -->
          <v-chip
            :color="['approve','acknowledge'].includes(item.status)? '#ECF8EA': ['reject'].includes(item.status)? '#FBE5E4': ['pending'].includes(item.status)? '#FEF5E9': ['cancel'].includes(item.status)? '#F5F5F5':'#ECF9FF'"
            :text-color="statusList.filter(e => e.status === item.status)[0].color"
          >
            <span>{{ statusList.filter(e => e.status === item.status)[0].statusTH || '-' }}</span>
          </v-chip>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                rounded
                color="#FFB300"
                dark
                icon
                class="ra-border-button mt-3 mb-3"
                @click="view(item)"
              >
              <v-icon color="#2BA197" small>mdi-eye</v-icon>
              </v-btn>
            </template>
            <span class="label-table-action">ดูรายละเอียด</span>
          </v-tooltip>
        </template>
        <template v-slot:item.data-table-expand="{ expand, isExpanded, item }">
          <v-row class="d-flex px-4">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  rounded
                  color="#FFB300"
                  dark
                  icon
                  class="ra-border-button mt-3 mb-3"
                  @click="view(item)"
                >
                <v-icon color="#2BA197" small>mdi-eye</v-icon>
                </v-btn>
              </template>
              <span class="label-table-action">ดูรายละเอียด</span>
            </v-tooltip>
          </v-row>
        </template>
      </v-data-table>
      <v-row>
      <v-col cols="12" class="pa-0">
      <div class="justify-end d-flex align-end pt-4">
        <v-pagination
          v-model="page"
          :length="pageCount"
          :total-visible="5"
        ></v-pagination>
      </div>
      </v-col>
    </v-row>
    </div>
    <!-- <DialogShowDetail/> -->
    <v-dialog
      v-model="dialog"
      persistent
      max-width="344"
      max-height="232"
    >
      <v-card tile class="justify-center">
        <v-card-title class="text-sub-color justify-center">
          <span style="font-family: Sarabun; font-style: normal; font-weight: bold; font-size: 16px; line-height: 22px; text-align: center;">
            {{ modeUpdate=='approve'? workfor=='approve'? 'ต้องการอนุมัติคำร้องใช่ไหม':'ต้องการไม่อนุมัติคำร้องใช่ไหม':'ต้องการรับทราบคำร้องใช่ไหม' }}
          </span>
        </v-card-title>
        <v-card-subtitle class="layout justify-center pt-1">
          <span style="font-family: Sarabun; font-style: normal; font-weight: 400; font-size: 16px; line-height: 22px; text-align: center; color: #757575; margin-top: 12px;">
            {{ modeUpdate=='approve'? workfor=='approve'? 'คุณแน่ใจหรือไม่ว่าต้องการอนุมัติคำร้อง':'คุณแน่ใจหรือไม่ว่าไม่ต้องการอนุมัติคำร้อง':'คุญแน่ใจหรือไม่ว่าต้องการรับทราบคำร้อง' }}
          </span>
        </v-card-subtitle>
        <v-textarea v-model="comment" class="ml-8 mr-8" outlined rows="2" placeholder="ระบุความเห็น" v-if="modeUpdate=='approve'"></v-textarea>
        <v-card-actions class="justify-center pb-4">
           <v-btn
              outlined
              class="button-color-outline head-search-button mr-4"
              width="83"
              @click="dialog = false"
            >
            ยกเลิก
            </v-btn>
            <v-btn
              class="button-color head-search-button ml-4 white--text text--lighten-4"
              elevation="0"
              width="83"
              @click="updateStatusApprove(workfor, modeUpdate, comment)"
            >
            ยืนยัน
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="text-center">
      <v-row>
        <v-snackbar
          v-model="snackbar"
          :timeout="timeout"
          :color="snackbarColor"
          text
          top
          app
          class="conten-alert"
        >
        <v-icon left dark small :color="snackbarColor">fa-check-circle</v-icon>
        <span :style="{ 'color': `${snackbarColor}` }">{{ workfor=='approve'? 'คุณได้ทำการอนุมัติคำร้องเรียบร้อย':'คุณได้ทำการไม่อนุมัติคำร้องเรียบร้อย' }}</span>
        </v-snackbar>
      </v-row>
    </div>
    <!-- <v-snackbar
      v-model="snackbar"
      :timeout="2000"
      top
      centered
      elevation="1"
      color="#ECF8EA"
      app
    >
      <v-icon dark color="#58A144" >mdi-check-circle-outline</v-icon>
      <span style="font-family: Sarabun; font-style: normal; font-weight: 400; font-size: 16px; line-height: 22px; text-align: center; color: #58A144;">
        {{ workfor=='approve'? 'คุณได้ทำการอนุมัติคำร้องเรียบร้อย':'คุณได้ทำการไม่อนุมัติคำร้องเรียบร้อย' }}
      </span>
    </v-snackbar> -->
  </div>
</template>

<script>
import { EventBus } from '@/EventBus'
import OverlayLoading from '../../_template/OverlayLoading.vue'
import { fetchAllRequesManageExternalToken } from '@/API/API'
const swal = require('sweetalert')
const axios = require('axios')
const moment = require('moment')
export default {
  name: 'tree',
  components: {
    OverlayLoading
  },
  props: {
    mode: String
  },
  data () {
    return {
      expanded: [],
      dialog: false,
      workfor: 'approve',
      modeUpdate: 'approve',
      comment: '',
      snackbar: false,
      timeout: 2000,
      snackbarColor: '',
      text: '',
      isAdmin: localStorage.approveRole === 'Super Admin' ? localStorage.approveRole === 'Super Admin' : false,
      // isAdmin: this.$store.state.user.role[1].permission === 'Super Admin' ? this.$store.state.user.role[1].permission === 'Super Admin' : false,
      singleSelect: false,
      allowBtnApprove: false,
      allowBtnReject: false,
      loading: false,
      filterData: {
        businessType: '',
        reqEmployeeNo: '',
        employeeName: '',
        companyName: [],
        position: [],
        requestType: [],
        status: [],
        approveType: this.modeUpdate,
        createAt: '',
        updateAt: '',
        limit: 15,
        page: 1
      },
      textBtnOk: this.modeUpdate === 'approve' ? 'อนุมัติ' : 'อนุมัติ',
      textBtnNO: this.modeUpdate === 'approve' ? 'ไม่อนุมัติ' : 'ไม่อนุมัติ',
      statusList: [
        // { status: 'pending', statusTH: 'กำลังดำเนินการ', color: '#00B0FF' },
        { status: 'pending', statusTH: 'รออนุมัติ', color: '#E9A016' },
        { status: 'approve', statusTH: 'อนุมัติแล้ว', color: '#58A144' },
        { status: 'reject', statusTH: 'ไม่อนุมัติ', color: '#D1392B' },
        { status: 'cancel', statusTH: 'ยกเลิก', color: '#757575' },
        { status: 'acknowledge', statusTH: 'รับทราบแล้ว', color: '#58A144' }
      ],
      headers: [
        {
          text: 'ลำดับ',
          value: 'no',
          width: '70px'
        },
        // { text: 'หมายเลขคำร้อง', value: 'reqBusinessNo', divider: true, align: 'left fixed' },
        { text: 'หมายเลขคำร้อง', value: 'reqTokenNo' },
        // { text: 'รูปภาพ', value: 'companyImage', width: '15%' },
        { text: 'ชื่อโปรเจค', value: 'projectName' },
        { text: 'ชื่อผู้ร้องขอ', value: 'userName' },
        { text: 'สถานะคำร้อง', value: 'status', width: '15%' },
        { text: 'จัดการ', value: 'data-table-expand', sortable: false, width: '100px', align: 'center fixed', class: 'column-fix' }

      ],
      checkBtnRehister: false,
      selected: [],
      dataSource: [],
      serviceTypeList: [],
      requestStatusList: [],
      total: -1,
      perPage: 15,
      pageCount: 0,
      page: 1,
      textCondition: {
        new: 'เพิ่มบุคคล',
        transfer: 'ขอย้ายฝ่าย',
        resign: 'ขอลาออก',
        transferPosition: 'ย้ายตำแหน่ง',
        resignPosition: 'ลาออกจากตำแหน่ง',
        resignEmployee: 'ลาออกจากบริษัท'
      },
      approveRole: localStorage.approveRole
    }
  },
  async created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.tokenUser = this.$store.state.token
    // await this.searchFilterData(this.filterData)
    // this.isAdmin = this.$store.state.user.role[1].permission === 'Super Admin'
    // this.loading = true
  },
  beforeDestroy () {
    EventBus.$off('openDialogManageApprove')
    EventBus.$off('manageApproveExternalToken')
    this.loading = false
  },
  mounted () {
    EventBus.$on('manageApproveExternalToken', this.setFilter)
  },
  methods: {
    onImgError (i) {
      this.dataSource[i].failed_image = true
    },
    changePerPage (value) {
      this.perPage = value
      this.setFilter(this.filterData)
    },
    changePage (value) {
      this.page = value
      this.setFilter(this.filterData)
    },
    async setFilter (value) {
      this.filterData = value
      var searchPayload = {
        tap: 'reqTokenTap',
        projectName: this.filterData.projectName,
        userName: this.filterData.userName,
        status: this.filterData.status || [''],
        reqTokenNo: this.filterData.reqTokenNo || '',
        role: this.filterData.role || this.approveRole,
        limit: this.perPage,
        page: this.page
      }
      this.searchFilterData(searchPayload)
    },
    async searchFilterData (value) {
      const self = this
      const temp = []
      self.loading = true
      self.selected = []
      self.filterData = value
      self.isAdmin = localStorage.approveRole === 'Super Admin'
      try {
        const res = await fetchAllRequesManageExternalToken(value, this.$store.state.token)
        if (res.success) {
          res.result.map((el, index) => {
            el.companyImage = `${this.api}/api/vMonk/companys/getcompanyFileById/` + el.companyImage
            temp.push({
              no: index + 1,
              failed_image: false,
              ...el
            })
          })
          self.total = res.count || -1
          EventBus.$emit('updateTotalCom', {
            totalAll: res.totalAll,
            totalApproved: res.totalApproved,
            totalPending: res.totalPending,
            totalRejected: res.totalRejected,
            totalWaiting: res.totalWaiting,
            totalCancel: res.totalCancel
          })
          self.total = res.total || -1
          // if (self.total + 1 === 0 && !self.isAdmin) {
          //   this.dialogRegisterCompany = true
          // }
          self.dataSource = temp || []
          self.computeData(self.dataSource)
          // EventBus.$emit('checkBtnRegister', res.checkReq)
        } else {
          self.dataSource = []
        }
      } catch (error) {
        console.log(error)
        self.dataSource = []
      } finally {
        self.loading = false
      }
    },
    async computeData (item) {
      await item.map(e => {
        e.createAt = moment(e.createAt).format('DD/MM/YYYY HH:mm น.')
        e.updateAt = moment(e.updateAt).format('DD/MM/YYYY HH:mm น.')
      })
    },
    // async updateAcknowledge (listId) {
    //   var obj = {
    //     acknowledgeList: listId
    //   }
    //   // console.log(obj)
    // },
    view (item) {
      this.$router.push('manageapprovetoken/updateManage/' + item._id)
    },
    checkAllowBtn () {
      if (this.selected.length > 0) {
        this.allowBtnApprove = true
        this.allowBtnReject = true
      } else {
        this.allowBtnApprove = false
        this.allowBtnReject = false
      }
    },
    clickApprove () {
      this.comment = ''
      this.dialog = true
      this.workfor = this.modeUpdate === 'approve' ? 'approve' : 'acknowledge'
    },
    clickReject () {
      this.comment = ''
      this.dialog = true
      this.workfor = 'reject'
    },
    async updateStatusApprove (task, modeUpdate, comment) {
      const self = this
      var confirmList = []
      self.selected.forEach(e => {
        confirmList.push(
          {
            // requestStatus: task,
            reqTokenId: e._id,
            commentRequest: comment
          }
        )
      })
      await axios({
        url: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/externalApi/updateStatusReqTokenByRole`,
        method: 'POST',
        headers: {
          authorization: this.$store.state.token
        },
        data: {
          status: task,
          role: this.approveRole,
          dataUpdate: confirmList
        }
      })
        .then((response) => {
          if (response.data.success === true) {
            // swal('สำเร็จ', 'ทำรายการเรียบร้อย', 'success', {
            //   button: false,
            //   timer: 2000
            // })
            this.dialog = false
            this.snackbarColor = 'success'
            this.snackbar = true
            this.page = 1
            EventBus.$emit('updateStatusToken', true)
            EventBus.$emit('updateDataDelete')
            self.searchFilterData(self.filterData)
          } else {
            swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
              button: false,
              timer: 2000
            })
          }
        })
        .catch(function (thrown) {
          swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
            button: false,
            timer: 2000
          })
        })
    },
    select (event) {
      this.checkAllowBtn()
    },
    selectAllToggle (props) {
      if (this.selected.length === 0) {
        this.selected = []
        const self = this
        props.items.forEach(item => {
          if (item.status === 'pending') {
            self.selected.push(item)
          }
        })
      } else this.selected = []
    }
  }
}
</script>

<style>
/* table */
.theme--light.v-pagination .v-pagination__item--active {
    background: #2BA197 !important;
    color: #FFFFFF;
}
.v-pagination__item {
    background: transparent;
    border-radius: 4px;
    font-size: 14px;
    height: 30px;
    margin: 0.3rem;
    min-width: 30px;
    padding: 0 5px;
    text-decoration: none;
    transition: 0.3s cubic-bezier(0, 0, 0.2, 1);
    width: auto;
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
}
.v-pagination__navigation {
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    height: 30px;
    width: 30px;
    margin: 0.3rem 10px;
}
/* end */
.v-data-table {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 16px;
}
.row-menu-left {
  justify-content: flex-start !important;
}
.row-menu-right {
  justify-content: flex-end !important;
}
.v-data-table tbody tr.v-data-table__expanded__content {
  box-shadow: inset 0px 4px 8px -5px rgba(50, 50, 50, 0), inset 0px -4px 8px -5px rgba(50, 50, 50, 0) !important;
}
.padding-left-90 {
  padding-left: 90px !important;
}
.table-name-row {
  display: flex;
  flex-direction: row;
}
.btn-edit-dep {
  background-color: #0370B7 !important;
  color: #fff !important;
}
.btn-del-dep {
  background-color: #da2525 !important;
  color: #fff !important;
}
</style>

<style scoped>

/* .table-approve >>> table > tbody > tr > td:nth-child(1),
.table-approve >>> table > thead > tr > th:nth-child(1) {
  position: sticky;
  position: -webkit-sticky;
  background: white;
  left: 0;
} */

/* .table-approve >>> table > tbody > tr > td:nth-child(2),
.table-approve >>> table > thead > tr > th:nth-child(2) {
  position: sticky;
  position: -webkit-sticky;
  background: white;
  left: 56px;
}

.table-approve >>> table > tbody > tr > td:nth-child(3),
.table-approve >>> table > thead > tr > th:nth-child(3) {
  position: sticky;
  position: -webkit-sticky;
  background: white;
  left: 126px;
} */

/* .table-approve >>> table > tbody > tr:hover > td:nth-child(1),
.table-approve >>> table > tbody > tr:hover > td:nth-child(2),
.table-approve >>> table > tbody > tr:hover > td:nth-child(3) {
  background: #eeeeee;
}

.table-approve >>> table > thead > tr > th:nth-child(1),
.table-approve >>> table > thead > tr > th:nth-child(2),
.table-approve >>> table > thead > tr > th:nth-child(3) {
  background-color: #F8F9FB;
}

.table-approve >>> table > tbody > tr.v-data-table__selected > td:nth-child(1),
.table-approve >>> table > tbody > tr.v-data-table__selected > td:nth-child(2),
.table-approve >>> table > tbody > tr.v-data-table__selected > td:nth-child(3) {
  background: #f7f7f7;
}

.table-approve >>> table > tbody > tr.v-data-table__selected:hover > td:nth-child(1),
.table-approve >>> table > tbody > tr.v-data-table__selected:hover > td:nth-child(2),
.table-approve >>> table > tbody > tr.v-data-table__selected:hover > td:nth-child(3) {
  background: #eeeeee;
} */
.border-table-business {
  border-radius: 10px;
  border: 1px solid rgb(229, 236, 238);
}

table > tbody > tr > td.fixed:nth-last-child(1),
table > thead > tr > th.fixed:nth-last-child(1) {
  position: sticky !important;
  position: -webkit-sticky !important;
  right: 0;
  /* z-index: 9997; */
  background: white;
  /* background: transparent; */
  -webkit-box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
  -moz-box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
  box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
}

table > tbody > tr:hover > td.fixed:nth-last-child(1), table > thead > tr:hover > th.fixed:nth-last-child(1) {
  background: #eeeeee;
}

table > thead > tr > th.fixed:nth-last-child(1) {
  /* z-index: 9998; */
  background-color: #F8F9FB;
}
.content-alert >>> .v-snack__wrapper {
  min-width: 15px !important;
}
</style>
